<div class="container-fluid">
    <app-frame [frameSrc]="url"></app-frame>
</div>
